import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';

interface Props {
  value?: boolean;
  title?: string;
}
interface Emits {
  (e: 'input', data: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiDrawer',
  props: {
    value: { type: Boolean, default: false },
    title: { default: 'Filter title' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: boolean): void;
}), expose: any, slots: any, attrs: any }) {




const wrap = ref();

const close = () => {
  emit('input', false);
};

onClickOutside(wrap, () => {
  close();
});

return { __sfc: true,emit, wrap, close }
}

})